<template>
    <v-list expand>
        <v-list-group
            :value="true"
            :ripple=false
            color="black"
            class="pt-6"
        >
            <template v-slot:activator>
                <v-list-item-title>
                    <TitleFilter :filterType="filterType"/>
                </v-list-item-title>
            </template>
            <BadgeItems
                v-if="filterType === 'tag'"
                :filterType="filterType"
                :filterData="filterData"
                @filter-method="filterBy"
            />
            <TextItems
                v-else
                :filterType="filterType"
                :filterData="filterData"
                @filter-method="filterBy"
            />
        </v-list-group>
    </v-list>
</template>

<script>
    import TextItems from "@/components/sidebar/cutaway/components/TextItems";
    import TitleFilter from "@/components/sidebar/cutaway/components/TitleFilter";
    import BadgeItems from "@/components/sidebar/cutaway/components/BadgeItems";

    export default {
        name: "CheckboxFilter",
        components: {
            TitleFilter,
            TextItems,
            BadgeItems
        },
        props: {
            filterData: {
                type: [Object, Array],
                required: true,
            },
            filterType: {
                type: String,
                required: true,
            }
        },
        methods: {
            filterBy(filter) {
                this.$emit('filter-method', filter);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-list-item__title {
        color: unset !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/sidebar/cutaway/components/CheckboxFilter.vue